<template>
  <div class="container">
    <div class="alert alert-success mt-4 mb-4" v-if="message">
      {{ message }}
    </div>
    <div class="card bg-light mt-4">
      <div class="signup-form">
        <form @submit.prevent="sendrequest">
          <div class="card-header pt-2">
            <h2 style="color: black" class="text-center">
              Inviaci la tua richiesta
            </h2>
          </div>

          <div class="card-body">
            <p class="mb-2 text-center">
              Compila tutti i campi e inviaci la tua richiesta! Entro 48h
              riceverai una email con la nostra risposta
            </p>
            <div class="form-group">
              <div class="row">
                <div class="col">
                  <input
                    type="text"
                    class="form-control"
                    v-model="register.name"
                    placeholder="Nome"
                    required="required"
                  />
                  <div class="alert alert-danger" v-if="errors.name">
                    {{ errors.name[0] }}
                  </div>
                </div>
                <div class="col">
                  <input
                    type="text"
                    class="form-control"
                    v-model="register.lastname"
                    placeholder="Cognome"
                    required="required"
                  />
                  <div class="alert alert-danger" v-if="errors.lastname">
                    {{ errors.lastname[0] }}
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <div class="col">
                  <input
                    type="email"
                    class="form-control"
                    v-model="register.email"
                    placeholder="Email"
                    required="required"
                  />
                  <div class="alert alert-danger" v-if="errors.email">
                    {{ errors.email[0] }}
                  </div>
                </div>
                <div class="col">
                  <input
                    type="text"
                    class="form-control"
                    v-model="register.phone"
                    placeholder="Recapito telefonico"
                    required="required"
                  />
                  <div class="alert alert-danger" v-if="errors.phone">
                    {{ errors.phone[0] }}
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <div class="form-group">
                  <select
                    class="form-control"
                    id="specializzazione"
                    required="required"
                    v-model="register.qualification_id"
                    @change="qualificationChange"
                  >
                    <option value="0" selected disabled>
                      Seleziona il reparto
                    </option>
                    <option
                      v-for="(qualification, index) in qualifications"
                      :key="index"
                      :value="qualification.id"
                    >
                      {{ qualification.name }}
                    </option>
                  </select>
                  <div
                    class="alert alert-danger"
                    v-if="errors.specialisation_id"
                  >
                    {{ errors.specialisation_id[0] }}
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="form-group">
                  <select
                    class="form-control"
                    v-model="register.specialisation_id"
                  >
                    <option value="0" selected disabled>
                      Seleziona la qualifica
                    </option>
                    <option
                      v-for="(specialisation, index) in specialisations"
                      :key="index"
                      :value="specialisation.id"
                    >
                      {{ specialisation.name }}
                    </option>
                  </select>
                  <div
                    class="alert alert-danger"
                    v-if="errors.qualification_id"
                  >
                    {{ errors.qualification_id[0] }}
                  </div>
                </div>
              </div>
              <div class="col" v-if="checkCompany">
                <input
                  type="text"
                  class="form-control"
                  name="company"
                  v-model="register.company"
                  placeholder="Nome azienda"
                />
                <div class="alert alert-danger" v-if="errors.company">
                  {{ errors.company[0] }}
                </div>
              </div>
            </div>
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                name="ospedale"
                v-model="register.hospital"
                placeholder="Ospedale o istituzione di competenza "
                required="required"
              />
              <div class="alert alert-danger" v-if="errors.hospital">
                {{ errors.hospital[0] }}
              </div>
            </div>
            <hr />

            <h5 class="card-title text-center mb-1">Trattamenti</h5>
            <p class="mb-2 text-center">
              Seleziona i trattamenti che ti interessa seguire
            </p>
            <div class="alert alert-danger" v-if="errors.patologies">
              {{ errors.patologies[0] }}
            </div>
            <div class="row">
              <div
                v-for="patology in patologies"
                :key="patology.id"
                class="col-md-2"
              >
                <!-- Categoria con icona per aprire/chiudere -->
                <div class="mb-1">
                  <input
                    type="checkbox"
                    v-model="register.patologies"
                    :value="patology.id"
                  />
                  {{ patology.name }}
                </div>

                <!-- Sottocategorie sovrapposte -->
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="form-group text-right" style="text-align: center">
              <button type="submit" class="btn btn-primary btn-lg">
                Invia la richiesta
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="hint-text mt-2 mb-4">
      Hai già un account? <a href="/login">Accedi subito</a>
    </div>
  </div>
</template>

<script>
import http from "@/services/http.js";
export default {
  name: "RegisterPage",
  props: {},
  data() {
    return {
      data: [],
      errors: [],
      qualifications: [],
      specialisations: [],
      patologies: [],
      register: {
        email: "",
        lastname: "",
        name: "",
        phone: "",
        qualification_id: 0,
        specialisation_id: 0,
        hospital: "",
        company: "",
        patologies: [],
        subpatologies: [],
      },
      message: "",
      user: "",
      checkCompany: false,
    };
  },
  mounted() {
    this.qualificationsData();
    this.specialisationsData();
    this.getPatologies();
  },
  methods: {
    toggleSubcategories(category) {
      category.subcategoriesVisible = !category.subcategoriesVisible;
    },
    async qualificationsData() {
      var { data } = await http.get("/qualifications");

      this.qualifications = data.data;
    },
    async specialisationsData() {
      var { data } = await http.get("/specialisations");
      this.specialisations = data.data;
    },
    async getPatologies() {
      var { data } = await http.get("/patology");
      this.patologies = data.data;
    },
    qualificationChange() {
      for (var i = 0; i < this.qualifications.length; i++) {
        if (
          parseInt(this.qualifications[i].id) ==
            parseInt(this.register.specialisation_id) &&
          this.qualifications[i].slug == "industria"
        ) {
          this.checkCompany = true;
          return;
        }
      }
      this.checkCompany = false;
    },
    sendrequest() {
      try {
        http
          .post("/request-users/store", this.register)
          .then((response) => {
            this.errors = [];
            this.message = response.data.message;
            this.register = {
              email: "",
              lastname: "",
              name: "",
              phone: "",
              qualification_id: 0,
              specialisation_id: 0,
              hospital: "",
              company: "",
            };
            // Gestisci l'array di oggetti come desiderato
          })
          .catch((error) => {
            this.errors = error.response.data.errors;
          });
      } catch (error) {
        this.errors = error.response.data.errors;
      }
    },
  },
};
</script>